import React from 'react';
import { createPortal } from 'react-dom';
import { NavLink } from 'react-router-dom';
import logo from '../assets/images/logo.png';
import {
    automatedMessage,
    calendarIcon,
    catalogueIcon,
    createServices,
    customersIcon,
    dashboardIcon,
    messageIcon,
    review,
    setting,
} from '../assets/images/sidebarIcons';
import useBusinessChatUnread from '../hooks/useBusinessChatUnread';
import { formatUnreadCount } from '../helpers/chatUtils';

const CloseIcon = () => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM15.36 14.3C15.65 14.59 15.65 15.07 15.36 15.36C15.21 15.51 15.02 15.58 14.83 15.58C14.64 15.58 14.45 15.51 14.3 15.36L12 13.06L9.7 15.36C9.55 15.51 9.36 15.58 9.17 15.58C8.98 15.58 8.79 15.51 8.64 15.36C8.35 15.07 8.35 14.59 8.64 14.3L10.94 12L8.64 9.7C8.35 9.41 8.35 8.93 8.64 8.64C8.93 8.35 9.41 8.35 9.7 8.64L12 10.94L14.3 8.64C14.59 8.35 15.07 8.35 15.36 8.64C15.65 8.93 15.65 9.41 15.36 9.7L13.06 12L15.36 14.3Z"
            fill="white"
        />
    </svg>
);

const handleLinkClick = () => {
    const closeBtn = document.querySelector('#businessMobileSidebar .btn-close-custom');
    if (closeBtn) {
        closeBtn.click();
    }
};

const BusinessMobileNavLink = ({ to, icon, label, badge }) => (
    <NavLink
        to={to}
        className="business-mobile-nav-link"
        activeClassName="active"
        exact={to === '/dashboard'}
        onClick={handleLinkClick}
    >
        <img src={icon} alt="" />
        <span>{label}</span>
        {badge ? <span className="business-mobile-nav-badge">{badge}</span> : null}
    </NavLink>
);

const BusinessMobileSidebar = () => {
    const unreadCount = useBusinessChatUnread();
    const chatBadgeLabel = formatUnreadCount(unreadCount);

    const menuItems = [
        { to: '/dashboard', icon: dashboardIcon, label: 'Home' },
        {
            to: '/dashboard/app/calendar/month',
            icon: calendarIcon,
            label: 'Calendar',
        },
        {
            to: '/dashboard/customer-history',
            icon: customersIcon,
            label: 'Customer History',
        },
        { to: '/dashboard/services', icon: createServices, label: 'Services' },
        { to: '/pricing-plan', icon: catalogueIcon, label: 'Pricing Plan' },
        { to: '/dashboard/members', icon: customersIcon, label: 'Members' },
        { to: '/dashboard/setting', icon: setting, label: 'Settings' },
        {
            to: '/dashboard/chat',
            icon: messageIcon,
            label: 'Chat',
            badge: chatBadgeLabel,
        },
        {
            to: '/dashboard/business-reviews',
            icon: review,
            label: 'Reviews',
        },
        {
            to: '/dashboard/automated-messages',
            icon: automatedMessage,
            label: 'Automated Messages',
        },
    ];

    const sidebar = (
        <div
            className="offcanvas offcanvas-end custom-mobile-sidebar business-mobile-offcanvas"
            tabIndex="-1"
            id="businessMobileSidebar"
            aria-labelledby="businessMobileSidebarLabel"
        >
            <div className="offcanvas-header">
                <img
                    src={logo}
                    alt="Next Salon"
                    className="img-fluid"
                    width={130}
                />
                <button
                    type="button"
                    className="btn-close-custom"
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                >
                    <CloseIcon />
                </button>
            </div>
            <div className="offcanvas-body">
                <nav className="business-mobile-nav">
                    {menuItems.map((item) => (
                        <BusinessMobileNavLink key={item.to} {...item} />
                    ))}
                </nav>
            </div>
        </div>
    );

    return createPortal(sidebar, document.body);
};

export default BusinessMobileSidebar;
